import React from 'react'
import PropTypes from 'prop-types'
import { useViewport } from '@chilecompra/react-kit'
import { Breadcrumb, Breadcrumbs } from '@chilecompra/react-kit/components'
import routes from '../../config/settings/routes'
import { useDownloadsNav, useDownloadsToggleNav } from '../Navigation/DownloadsNavButton.context'
import Jumbotron from '../Basics/Jumbotron'
import {
  Content,
  Description,
  GridContainer,
  GridItem,
  HideContainer,
  Item,
  Link,
  NavContainer,
  NavOverlay,
  Root,
  Title
} from './DownloadsLayout.styles'

/**
 * The DownloadsLayout's component.
 */
const DownloadsLayout = props => {
  const { children, menuActive } = props
  const navToggle = useDownloadsNav()
  const toggleNav = useDownloadsToggleNav()
  const {
    size: { isUpToMedium }
  } = useViewport()
  return (
    <Root>
      <GridContainer>
        <GridItem xs={12}>
          <Jumbotron color="blue" height={isUpToMedium ? '295px' : 'auto'}>
            <Breadcrumbs>
              <Breadcrumb to={routes.root} variant="link">
                Datos Abiertos
              </Breadcrumb>
              <Breadcrumb>Descargas</Breadcrumb>
            </Breadcrumbs>
            <Title>Descargas</Title>
            <Description>
              Descarga reportes de órdenes de compra y licitaciones, datos de las compras
              <br /> públicas con el estándar OCDS, servicios y productos que se transan a través de
              <br /> Convenio Marco y más.
            </Description>
          </Jumbotron>
        </GridItem>
      </GridContainer>
      <Content>
        <GridContainer spacing={2}>
          {navToggle ? (
            <>
              <NavContainer>
                <Item>
                  <Link
                    active={menuActive === routes.downloads || menuActive === routes.downloadOrderAndBiddings}
                    to={routes.downloadOrderAndBiddings}
                  >
                    Órdenes de compra y licitaciones
                  </Link>
                </Item>
                <Item>
                  <Link active={menuActive === routes.downloadAgilePurchase} to={routes.downloadAgilePurchase}>
                    Cotizaciones de compra ágil
                  </Link>
                </Item>
                <Item>
                  <Link active={menuActive === routes.downloadOCDS} to={routes.downloadOCDS}>
                    Procesos de compra OCDS
                  </Link>
                </Item>
                <Item>
                  <Link active={menuActive === routes.downloadFramework} to={routes.downloadFramework}>
                    Productos y servicios en Convenio Marco
                  </Link>
                </Item>
                <Item>
                  <Link
                    active={menuActive === routes.downloadLargePurchaseProcesses}
                    to={routes.downloadLargePurchaseProcesses}
                  >
                    Procesos de Gran Compra
                  </Link>
                </Item>
                <Item>
                  <Link active={menuActive === routes.downloadPurchasePlan} to={routes.downloadPurchasePlan}>
                    Plan Anual de Compra
                  </Link>
                </Item>
                <Item>
                  <Link active={menuActive === routes.downloadAddons} to={routes.downloadAddons}>
                    Datos <br />
                    Complementarios
                  </Link>
                </Item>
                <Item>
                  <Link active={menuActive === routes.downloadDevelopmentTools} to={routes.downloadDevelopmentTools}>
                    Herramientas para desarrolladores
                  </Link>
                </Item>
                <Item>
                  <Link active={menuActive === routes.downloadCfmp} to={routes.downloadCfmp}>
                    Registro de Compras Fuera de Mercado Público
                  </Link>
                </Item>
              </NavContainer>
              <NavOverlay onClick={toggleNav} />
            </>
          ) : (
            <HideContainer only={['xs', 'sm']}>
              <GridItem xs={12} md={3}>
                <Item>
                  <Link
                    active={menuActive === routes.downloads || menuActive === routes.downloadOrderAndBiddings}
                    to={routes.downloadOrderAndBiddings}
                  >
                    Órdenes de compra y licitaciones
                  </Link>
                </Item>
                <Item>
                  <Link active={menuActive === routes.downloadAgilePurchase} to={routes.downloadAgilePurchase}>
                    Cotizaciones de compra ágil
                  </Link>
                </Item>
                <Item>
                  <Link active={menuActive === routes.downloadOCDS} to={routes.downloadOCDS}>
                    Procesos de compra OCDS
                  </Link>
                </Item>
                <Item>
                  <Link active={menuActive === routes.downloadFramework} to={routes.downloadFramework}>
                    Productos y servicios en Convenio Marco
                  </Link>
                </Item>
                <Item>
                  <Link
                    active={menuActive === routes.downloadLargePurchaseProcesses}
                    to={routes.downloadLargePurchaseProcesses}
                  >
                    Procesos de Gran Compra
                  </Link>
                </Item>
                <Item>
                  <Link active={menuActive === routes.downloadPurchasePlan} to={routes.downloadPurchasePlan}>
                    Plan Anual de Compra
                  </Link>
                </Item>
                <Item>
                  <Link active={menuActive === routes.downloadAddons} to={routes.downloadAddons}>
                    Datos <br />
                    Complementarios
                  </Link>
                </Item>
                <Item>
                  <Link active={menuActive === routes.downloadDevelopmentTools} to={routes.downloadDevelopmentTools}>
                    Herramientas para desarrolladores
                  </Link>
                </Item>
                <Item>
                  <Link active={menuActive === routes.downloadCfmp} to={routes.downloadCfmp}>
                    Registro de Compras Fuera de Mercado Público
                  </Link>
                </Item>
              </GridItem>
            </HideContainer>
          )}
          <GridItem xs={12} md={9}>
            {children}
          </GridItem>
        </GridContainer>
      </Content>
    </Root>
  )
}

DownloadsLayout.defaultProps = {
  menuActive: routes.root
}

DownloadsLayout.propTypes = {
  children: PropTypes.node.isRequired,
  menuActive: PropTypes.string
}

export default DownloadsLayout
